import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export default function ImpressumPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Impressum · Die Lichtmalerin";
  }, []);

  return (
    <div
      className="relative min-h-screen bg-[#090909]"
      data-testid="impressum-page"
    >
      {/* Ambient glow */}
      <div
        className="ambient-glow"
        style={{
          width: 500,
          height: 500,
          background: "rgba(212, 175, 55, 0.08)",
          top: "-10%",
          left: "10%",
        }}
      />

      {/* Simple top bar */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-12 pt-10 md:pt-12">
        <Link
          to="/"
          data-testid="impressum-back-link"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.35em] font-sans font-light text-[#A1A1AA] hover:text-[#D4AF37] transition-colors group"
        >
          <ArrowLeft
            size={14}
            strokeWidth={1.4}
            className="group-hover:-translate-x-1 transition-transform"
          />
          <span>Zurück</span>
        </Link>
      </div>

      <section
        id="impressum"
        data-testid="impressum-section"
        className="relative py-16 md:py-24 px-6 lg:px-12"
      >
        <div className="max-w-3xl mx-auto">
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="gold-divider"
            data-testid="impressum-eyebrow"
          >
            Rechtliches
          </motion.span>

          <motion.h1
            data-testid="impressum-heading"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#E5E5E5] mt-8 mb-12"
          >
            Impressum
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.2, ease: "easeOut" }}
            className="space-y-8 font-sans font-light text-[#E5E5E5]/85 text-base leading-relaxed"
            data-testid="impressum-body"
          >
            <div>
              <p className="font-serif italic text-[#D4AF37] text-lg mb-2">
                Angaben gemäß § 5 TMG
              </p>
              <p data-testid="impressum-name">Nicole Meinhold</p>
              <p>Die Lichtmalerin</p>
              <p>Teichdamm 3</p>
              <p>38855 Wernigerode</p>
            </div>

            <div>
              <p className="font-serif italic text-[#D4AF37] text-lg mb-2">
                Kontakt
              </p>
              <p>
                E-Mail:{" "}
                <a
                  href="mailto:die_lichtmalerin@web.de"
                  data-testid="impressum-email"
                  className="text-[#E5E5E5] hover:text-[#FDE047] transition-colors underline underline-offset-4 decoration-[#D4AF37]/40"
                >
                  die_lichtmalerin@web.de
                </a>
              </p>
              <p>
                Telefon:{" "}
                <a
                  href="tel:+4901751052691"
                  data-testid="impressum-phone"
                  className="text-[#E5E5E5] hover:text-[#FDE047] transition-colors underline underline-offset-4 decoration-[#D4AF37]/40"
                >
                  01751052691
                </a>
              </p>
            </div>

            <div>
              <p className="font-serif italic text-[#D4AF37] text-lg mb-2">
                Umsatzsteuer
              </p>
              <p className="text-[#A1A1AA] italic">
                Umsatzsteuer-Identifikationsnummer wird derzeit beantragt.
              </p>
            </div>

            <div>
              <p className="font-serif italic text-[#D4AF37] text-lg mb-2">
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
              </p>
              <p>Nicole Meinhold</p>
              <p>Teichdamm 3</p>
              <p>38855 Wernigerode</p>
            </div>

            <div>
              <p className="font-serif italic text-[#D4AF37] text-lg mb-2">
                Bildrechte
              </p>
              <p>
                Alle gezeigten Fotografien stammen von Nicole Meinhold /
                die Lichtmalerin. Jede weitere Verwendung, Vervielfältigung
                oder Veröffentlichung bedarf der ausdrücklichen Zustimmung.
              </p>
            </div>
          </motion.div>

          {/* Footer */}
          <footer
            data-testid="site-footer"
            className="relative z-10 mt-24 pt-10 border-t border-[#D4AF37]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-sans font-light text-[#A1A1AA] uppercase tracking-[0.35em]"
          >
            <p data-testid="footer-copyright">
              © {new Date().getFullYear()} · Nicole Meinhold
            </p>
            <p className="font-serif italic normal-case tracking-normal text-[#D4AF37]/70 text-sm">
              Aus der Dunkelheit — ein Funke.
            </p>
            <p data-testid="footer-tag">Die Lichtmalerin · Wernigerode</p>
          </footer>
        </div>
      </section>
    </div>
  );
}
